<template>
  <div id="ColorPanel">
    <div
      class="left col-xs-3"
      :class="{ 'col-xs-offset-2' : format == 'single', mb20 : $store.getters.isVertical}"
    >
      <p>Backlight Style:</p>
      <color-picker
        class="mr20 el-color-picker"
        v-model="globalColor"
        @input="setColors"
        :color="globalColor"
      />
      <el-button
        @click="resetColor()"
        class="br0 elbut"
        title="Reset the Color"
      >
        <i class="el-icon-refresh-right"></i>
      </el-button>
    </div>

    <div :class="{left: true, 'col-xs-3': !$store.getters.isVertical, 'col-xs-12' : $store.getters.isVertical}">
      <div class="row mlr0 flex">
        <div
          v-for="(i, index) in content"
          :key="index"
          class=" prl7 mb10"
          :class="type == 'alba' || type == 'blackjack' ? 'col-xs-6' : 'col-xs-4'"
        >
          <div class="p5 border">
            <color-picker v-model="i.color" :color="i.color" />
          </div>
        </div>
      </div>
    </div>

    <div :class="{
      right: true, 
      'col-xs-3 bdr-d': !$store.getters.isVertical, 'bdrt-d col-xs-12' : $store.getters.isVertical}" v-if="format != 'single'">
      <div class="row mlr0 flex">
        <div
          class="prl7 mb10"
          :class="type == 'alba' ? 'col-xs-6' : 'col-xs-4'"
          v-for="(i, index) in rightContent"
          :key="index"
        >
          <div class="p5 border">
            <color-picker v-model="i.color" :color="i.color" />
          </div>
        </div>
      </div>
    </div>

    <div :class="{'col-xs-3 bdr-d': !$store.getters.isVertical, 'bdrt-d col-xs-12' : $store.getters.isVertical}" v-if="$store.getters.isTriple">
      <div class="row mlr0 flex">
        <div
          class="prl7 mb10"
          :class="type == 'alba' ? 'col-xs-6' : 'col-xs-4'"
          v-for="(i, index) in tripleRightContent"
          :key="index"
        >
          <div class="p5 border">
            <color-picker v-model="i.color" :color="i.color" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ColorPicker from "../../../components/ColorPicker.vue";
export default {
  name: "ColorPanel",
  components: {
    ColorPicker,
  },
  data() {
    return {
      type: null,
      content: null,
      rightContent: null,
      tripleRightContent: null,
      format: null,
      globalColor: null,
    };
  },
  methods: {
    resetColor() {
      if (this.$store.state.artwork.type == "aria") {
        this.$store.commit(
          "changeFontColor", this.$store.state.defaultIconColors[this.$store.state.artwork.frameColor]
        );
      } else {
        this.$store.commit(
          "changeFontColor", this.$store.state.defaultIconColors[this.$store.state.artwork.keyColor]
        );
      }
    },
    setColors(e) {
      for (var i = 0; i < this.content.length; i++) {
        this.$set(this.content[i], "color", e);
      }
    },
  },
  created() {
    //read from store
    this.type = this.$store.state.artwork.type;
    this.format = this.$store.state.artwork.format;
    this.content = this.$store.state.artwork.content;
    this.rightContent = this.$store.state.artwork.rightContent;
    this.tripleRightContent = this.$store.state.artwork.tripleRightContent;
  },
  watch: {
    globalColor: {
      deep: true,
      handler(color) {
        for (var i = 0; i < this.$store.state.artwork.content.length; i++) {
          this.$store.state.artwork.content[i].color = color;
        }

        if (this.$store.state.artwork.format != "single") {
          for (i = 0; i < this.$store.state.artwork.rightContent.length; i++) {
            this.$store.state.artwork.rightContent[i].color = color;
          }
        }

        if (this.$store.getters.isTriple) {
          for (i = 0; i < this.$store.state.artwork.tripleRightContent.length; i++) {
            this.$store.state.artwork.tripleRightContent[i].color = color;
          }
        }
      },
    },
  },
};
</script>
